import { isPlatformBrowser } from '@angular/common';
import { ErrorHandler, Inject, Injectable, PLATFORM_ID } from '@angular/core';

import { UserError } from '~/errors/class/error/user-error';
import { ToastsService } from '~/notifications/toasts/toasts.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(
    private readonly toastsService: ToastsService,
    @Inject(PLATFORM_ID) private readonly platformId: boolean
  ) {}

  public handleError(error: Error): void {
    if (error instanceof UserError) {
      this.toastsService.push(error);
      return;
    }
    console.error(error);
  }

  public initialize(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
  }
}
